import { type UseQueryResult, useQuery } from 'react-query';
import { EmployeeTypeService } from '@wealthlane/api-services/wealthlane-customer-service';
import { EarlyExerciseConfigurationService } from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useGetCashSellTypeSettlementType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const cashSellTypeSettlementType = useQuery(
    ['getCashSellTypeSettlementType'],
    async () => {
      return await handleRequest(
        EarlyExerciseConfigurationService.getApiAwardSettlementApiAppEarlyExerciseConfigurationCashSellTypeSettlementTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.settlementType ?? '',
            value: item.settlementTypeId ?? '',
          };
        });
      },
    }
  );

  return cashSellTypeSettlementType;
};

export default useGetCashSellTypeSettlementType;
